import { renderToggleButton_unstable } from '@fluentui/react-button';

/**
 * Renders the final JSX of the ToggleButton component, given the state.
 */
export const renderToggleButton = renderToggleButton_unstable;
